import { Box, Chip, Typography } from "@mui/material";
import { formatInAppNotificationExpiry } from "../../utils/inAppNotificationUtils";
import { useDesignTokens } from "../../theme/useDesignTokens";

const SelectedNotificationSummary = ({ notification }) => {
  const { colors, font } = useDesignTokens();

  if (!notification) {
    return null;
  }

  const expiryLabel = formatInAppNotificationExpiry(notification.expiry);

  return (
    <Box
      sx={{
        mt: { xs: 1.5, md: 2 },
        p: { xs: 1.5, md: 2 },
        borderRadius: 1.5,
        border: `1px solid ${colors?.ghost?.light || "#E0E0E0"}`,
        bgcolor: colors?.primary?.lightest || "rgba(25, 118, 210, 0.04)",
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 600 }}
      >
        Selected notification
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: font?.weight?.fontW700 || 700, mt: 0.5, mb: 1 }}
      >
        {notification.title}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        <Chip label={notification.type} size="small" variant="outlined" />
        <Chip label="User-specific" size="small" color="primary" variant="outlined" />
        <Chip label={`Expires ${expiryLabel}`} size="small" variant="outlined" />
      </Box>
    </Box>
  );
};

export default SelectedNotificationSummary;
